import { styled } from '@superset-ui/core';
import React, { useState } from 'react';

interface Props {
    title: string;
    subTitle: string;
    iconLabel: string;
    labelIcon: any;
    cardIcon: any;
    hoverIcon: any;
}

const StyledDiv = styled.div`
display: flex;
height: 100%;
.icon-card {
    padding: 1.4rem 1rem;
    border: 1px solid #D6DEEB;
    border-radius: 8px;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    min-width: 16rem;
    cursor: pointer;
    gap: 3rem;
    transition: 1s;
}

.icon-card:hover {
    background: #E6EEFF;
}

.icon-card-cardText {
    display: flex;
    flex-direction: column;
    gap: .2em;
}

.icon-card-imgBox {
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-card-iconRow {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: .5em;
}

.icon-card-iconLabel {
    font-weight: 400;
    font-size: .7rem;
    line-height: .8rem;
    color: #A7A9BC;
}

.icon-card-title {
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.1rem;
    white-space: nowrap;
}

.icon-card-subTitle {
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.1rem;
    color: #6B6C7E;
    white-space: nowrap;
}`;

const Card = (props: Props) => {
    const [ cardIcon, setIcon ] = useState(props.cardIcon);

    const handleMouseOver = () => {
        setIcon(props.hoverIcon);
    }

    const handleMouseOut = () => {
        setIcon(props.cardIcon);
    }

    return (
        <StyledDiv onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <div className='icon-card'>
                <div className='icon-card-cardText'>
                    <div className='icon-card-iconRow'>
                        <img src={props.labelIcon} alt="" />
                        <div className='icon-card-iconLabel'>
                            {props.iconLabel}
                        </div>
                    </div>
                    <div className='icon-card-title'>
                        {props.title}
                    </div>
                    <div className='icon-card-subTitle'>
                        Modified {props.subTitle}
                    </div>
                </div>

                <div className='icon-card-imgBox'>
                    <img src={cardIcon} alt="" />
                </div>
            </div>
        </StyledDiv>
    );
};

export default Card;